import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.css']
})

export class ProgressComponent implements OnInit {
  @Input() progress = 0;
  @Input() status = '#303030';
  constructor() {}
  ngOnInit() {}
}
